












































import { defineComponent } from '@vue/composition-api';

import useDeliveryAreaCode from '@/useDeliveryAreaCode';
import useDeliveryNoteStatus from '@/useDeliveryNote';
import useDelivery from '@/useDelivery';

import ProgressRenderer from '@/components/DeliveryNote/ProgressRenderer.vue';

const SystemDisplay = defineComponent({
  components: {
    ProgressRenderer,
  },
  setup() {
    const { distanceTypeToChipClass, translateDistanceType, distanceTypeToColor } = useDeliveryAreaCode();
    const { english: deliveryStatus, shipmentStatusClassMap, translate: deliveryTranslate } = useDelivery();
    const { english: deliveryNoteStatus, deliveryNoteStatusClassMap, translate: deliveryNoteTranslate } = useDeliveryNoteStatus();

    return {
      deliveryStatus,
      deliveryNoteStatus,

      distanceTypeToChipClass,
      translateDistanceType,
      distanceTypeToColor,

      shipmentStatusClassMap,
      deliveryTranslate,

      deliveryNoteStatusClassMap,
      deliveryNoteTranslate,
    };
  },
});

export default SystemDisplay;
